@switch (bannerStyle) {
  @case ('Full') {
    <div class="cta relative flex flex-col md:flex-row items-center overflow-hidden rounded-md bg-blue-50 px-4 py-4 text-white">
      <div class="text-center md:relative md:flex md:items-center">
        <div class="md:relative md:-bottom-2 -ml-24 hidden md:flex">
          <img
            [src]="'/promotion-banner/march-madness-2024/march-maddness-loud-speaker.png' | staticAsset: 'image'"
            alt=""
            class="relative md:-mb-8 max-h-[180px]"
          />
        </div>
        <div class="z-50 flex flex-col gap-2 ml-4 mr-8">
          <strong class="text-white text-[1rem] uppercase"> Mid year sale </strong>
          <div class="mb-4 flex flex-col gap-2">
            <img [src]="'/promotion-banner/march-madness-2024/march-madness-off.png' | staticAsset: 'image'" alt="" class="h-[95px]" />
            <p class="text-small uppercase">an annual Pro subscription</p>
          </div>
        </div>
      </div>
      <div class="">
        <div class="text-center">
          <p class="text-white text-heading-1 text-center md:text-left">Automate your social content!</p>
          <p class="uppercase text-highlight-yellow text-heading-1 md:text-left">Save $356</p>
        </div>
        <div class="mt-2 md:!absolute md:bottom-4 md:right-10 md:mt-0 flex flex-col text-center">
          <a
            routerLink="/billing/plans"
            [queryParams]="{ tier: 'Professional' }"
            target="_blank"
            class="upgrade-button mx-auto"
            mat-flat-button
          >
            Claim Offer
          </a>
          <p class="uppercase">Exires June 30</p>
        </div>
      </div>
      <div class="md:hidden -mb-24">
        <img
          [src]="'/promotion-banner/march-madness-2024/march-maddness-loud-speaker.png' | staticAsset: 'image'"
          alt=""
          class="max-h-[180px]"
        />
      </div>
    </div>
  }
  @case ('NoCta') {
    <div class="noCta relative flex flex-col items-center overflow-hidden rounded-md bg-blue-50 px-4 py-2 text-white md:px-6 lg:px-12">
      <div class="text-center md:relative md:flex md:w-full md:items-center md:justify-between">
        <div class="flex flex-col grow md:flex-row md:items-center md:gap-4">
          <div class="mb-4 flex flex-col gap-2 md:mb-0">
            <strong class="uppercase">Mid year sale</strong>
            <img
              [src]="'/promotion-banner/march-madness-2024/march-madness-off.png' | staticAsset: 'image'"
              alt=""
              class="max-h-[4.5rem]"
            />
            <p class="text-small uppercase">an annual Pro subscription</p>
          </div>
          <div class="grow text-heading-2">
            <strong class="heading text-white uppercase">Automate your social content! </strong>
            <p class="uppercase text-highlight-yellow">Save $356</p>
          </div>
        </div>
        <div class="hidden scale-x-[-1] md:relative md:flex">
          <img
            [src]="'/promotion-banner/march-madness-2024/march-maddness-loud-speaker.png' | staticAsset: 'image'"
            alt=""
            class="max-h-[52px] md:max-h-[120px]"
          />
        </div>
      </div>
    </div>
  }
  @case ('Small') {
    <div class="checkout-container bg-blue-90 text-white rounded-md py-2 text-center font-bold">
      Almost there! You&rsquo;re *this* close to getting <span class="text-highlight-yellow"> 30% off</span> RateMyAgent Pro
    </div>
  }
}
